import React, {ForwardedRef, forwardRef} from 'react'
import {DashboardMenuLink} from '../../../Dashboard/shared/Layout/MenuLink'
import {EventsMenuLink} from '../../../Events/shared/Layout/MenuLink'
import {UsersMenuLink} from '../../../Users/shared/Layout/MenuLink'
import {LocationsMenuLink} from '../../../Locations/shared/Layout/MenuLink'
import {CurrentUserStatusInteractiveCard} from '@src/modules/Users/shared/Layout/CurrentUserStatusInteractiveCard'
import {RecordsMenuLink} from '@src/modules/Records/shared/Layout/MenuLink'
import {ReportsMenuLink} from '@src/modules/Reports/shared/Layout/MenuLink'
import {Clock} from '@src/modules/Layout/components/LeftMenu/components/Clock'
import {SchedulingMenuLink} from '@src/modules/Scheduling/shared/Layout/MenuLink'
import {ErrorBoundary, useCurrentOrganization} from '@therms/react-modules'
import {MailMenuLink} from '@src/modules/Mail/shared/Layout/MenuLink'
import {PatrolMenuLink} from '@src/modules/Patrol/shared/Layout/MenuLink'
import {BulletinsMenuLink} from '@src/modules/Bulletins/shared/Layout/MenuLink'
import {ReviewMenuLink} from '@src/modules/Review/shared/Layout/MenuLink'

const DesktopLeftMenu = forwardRef(
  (props, ref: ForwardedRef<HTMLDivElement>) => {
    const {
      modules: {patrol, scheduling},
    } = useCurrentOrganization()

    return (
      <div className="bg-surface px-xs flex w-64 shrink-0 flex-col" ref={ref}>
        <Clock />

        <div className="mt-xxs" />

        <ErrorBoundary>
          <CurrentUserStatusInteractiveCard />
        </ErrorBoundary>

        <nav className="space-y-xxs py-sm grow overflow-y-auto">
          <DashboardMenuLink />

          <EventsMenuLink />

          <LocationsMenuLink />

          {patrol && <PatrolMenuLink />}

          <RecordsMenuLink />

          <ReportsMenuLink />

          <UsersMenuLink />

          {scheduling && <SchedulingMenuLink />}

          <ReviewMenuLink />
        </nav>

        <div className="border-border border-t" />

        <nav className="py-xxs space-y-xxs">
          <BulletinsMenuLink />
          <MailMenuLink />
        </nav>
      </div>
    )
  },
)

export {DesktopLeftMenu}
